module.exports = __webpack_public_path__ + "img/SP.3a971cc6.svg";